// Module
var code = `<div class="col-lg-12">
    <bfg-chart name="runner_battler.RbCampaignWinRateChart"></bfg-chart>
</div>
`;
// Exports
module.exports = code;